import { useQuery } from '@tanstack/react-query'
import { useCogfy } from './use-cogfy'
import { GetWorkspaceCreditsUsageQuery } from '@indigohive/cogfy-types/endpoints/getWorkspaceCreditsUsage'

export function useWorkspaceCreditsUsage (
  workspace: string,
  query: GetWorkspaceCreditsUsageQuery
) {
  const cogfy = useCogfy()

  const getWorkspaceCreditsUsage = useQuery({
    queryKey: ['getWorkspaceCreditsUsage', workspace, query],
    queryFn: ({ signal }) => cogfy.getWorkspaceCreditsUsage(query, { signal })
  })

  return getWorkspaceCreditsUsage
}
